import { useEffect } from "react";
import { useDispatch } from "react-redux";
import './assets/scss/themes.scss';
import RouteIndex from 'Routes/Index';
import { receiveMessage } from "slices/chat/reducer";
import { receiveDirectMessage } from "slices/communication/reducer";
import { getDirectContacts } from "slices/communication/thunk";
import { getContact } from "slices/contact/thunk";
import { startConnection, stopConnection } from "services/signalr.service";
import { toast } from "react-toastify";
import { getKnowledgeDetail } from "slices/thunk";


function App() {
  const dispatch = useDispatch<any>();
  // Listen event from server through SignalR
  useEffect(() => {
    const cleanup = initSignalRConnection();
    return () => {
      cleanup.then((fn) => fn && fn());
    };
  }, []);

  // Preload direct-message contacts so the header unread badge works app-wide.
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      dispatch(getDirectContacts());
    }
  }, [dispatch]);

  const initSignalRConnection = async () => {
    startConnection(
      async (message: any) => {
        setTimeout(async () => {
          await dispatch(receiveMessage(message));
        }, 100);
      },
      async () => {
        await dispatch(getContact({}));
        toast.success("Contact data sync completed!", { autoClose: 2000 });
        if (window.location.pathname === "/setting/integrations") {
          window.location.reload();
        }
      },
      () => {
        toast.success("Working hour settings updated successfully!", { autoClose: 2000 });
      },
      async (datasetId: any) => {
        await dispatch(getKnowledgeDetail(datasetId));
        // toast.success("Knowledge base processing completed!", { autoClose: 2000 });
      },
      async (message: any) => {
        await dispatch(receiveDirectMessage(message));
      }
    );

    return () => {
      stopConnection();
    };
  };

  return (
    <RouteIndex />
  );
}

export default App;
